import { Stack, SwipeableDrawer } from '@mui/material'
import { logDrawerDataSignal, logDrawerOpenSignal } from './logCard'
import { Typography } from '@eventr/common-storybook'

export const LogDrawer = () => {
    const toggleDrawer = (newOpen: boolean) => () => {
        if (!newOpen) {
            logDrawerOpenSignal.value = false
        }
    }

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={logDrawerOpenSignal.value}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            ModalProps={{
                keepMounted: false,
            }}
        >
            <Stack overflow={'auto'} height={'500px'} margin={'20px'}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography color={'black'}>
                        {new Date(
                            logDrawerDataSignal.value?.timeStamp
                        ).toLocaleString()}
                    </Typography>
                    <Stack direction={'row'} spacing={'5px'}>
                        {logDrawerDataSignal.value?.tags.map((t, i) => {
                            return (
                                <Typography
                                    key={i}
                                    children={t}
                                    color={'black'}
                                />
                            )
                        })}
                    </Stack>
                </Stack>

                <pre>
                    {JSON.stringify(
                        logDrawerDataSignal.value?.message,
                        null,
                        2
                    )}
                </pre>

                {logDrawerDataSignal.value?.extraArgs?.map((arg, i) => {
                    return <pre key={i}>{JSON.stringify(arg, null, 2)}</pre>
                })}
            </Stack>
        </SwipeableDrawer>
    )
}
